import { useMemo, useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { UserData } from '../../types';
import { computeDAUHistory, formatDateLabel } from '../../lib/metrics';

interface ActiveUsersChartProps {
  users: UserData[];
  fullWidth?: boolean;
}

export function ActiveUsersChart({ users, fullWidth = true }: ActiveUsersChartProps) {
  const [range, setRange] = useState<'7d' | '30d' | 'all'>('30d');

  const data = useMemo(() => {
    const days = range === '7d' ? 7 : range === '30d' ? 30 : 90;
    return computeDAUHistory(users, days).map(d => ({
      ...d,
      date: formatDateLabel(d.date),
    }));
  }, [users, range]);

  return (
    <div className={`chart-card${fullWidth ? ' chart-full-width' : ''}`}>
      <div className="chart-header">
        <h3>Daily Active Users</h3>
        <div className="chart-range-toggle">
          <button className={range === '7d' ? 'active' : ''} onClick={() => setRange('7d')}>7d</button>
          <button className={range === '30d' ? 'active' : ''} onClick={() => setRange('30d')}>30d</button>
          <button className={range === 'all' ? 'active' : ''} onClick={() => setRange('all')}>All</button>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={fullWidth ? 280 : 250}>
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="date" fontSize={11} tick={{ fill: '#6b7280' }} />
          <YAxis fontSize={11} tick={{ fill: '#6b7280' }} allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Area type="monotone" dataKey="mau" name="MAU" stroke="#dbeafe" fill="#dbeafe" strokeWidth={0} />
          <Area type="monotone" dataKey="wau" name="WAU" stroke="#93c5fd" fill="#93c5fd" strokeWidth={0} />
          <Area type="monotone" dataKey="dau" name="DAU" stroke="#2563eb" fill="#2563eb" strokeWidth={0} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
